import * as items from './items.jsx';
import * as ReactBootstrap from 'react-bootstrap';
import numeral from 'numeral';

class TransactionStatusIcon extends waffle.base.BaseComponent {
  getIconForState(state) {
    if (state in this.props.stateIcons) {
      return this.props.stateIcons[state]
    } else {
      return this.props.default
    }
  }

  getClassForState(state) {
    if (state in this.props.stateClass) {
      return this.props.stateClass[state]
    } else {
      return this.props.default
    }
  }

  getIconForType(type) {
    if (type in this.props.typeIcons) {
      return this.props.typeIcons[type]
    } else {
      return this.props.default
    }
  }

  getNewIconForStatus() {
    var status = this.props.transaction.transactionState;
    if (status == "aborted" || status == "error") {
      return <div className="status-circle aborted"></div>
    } else if (status == "declined") {
      return <div className="status-circle declined"></div>
    }

    if (this.props.transaction.transactionType == "refund") {
      return <div className="status-circle refunded">
        <i className="icon-refresh"></i>
      </div>
    }

    return
  }

  render() {
    var transactionType = "";
    var transactionState = "";
    if (this.props.transaction) {
      transactionType = this.props.transaction["transactionType"];
      transactionState = this.props.transaction["transactionState"];
    }

    var stateClass = this.getClassForState(transactionState);
    var stateIcon = this.getIconForState(transactionState);
    var typeIcon = this.getIconForType(transactionType);

    var title = "Transaction";
    if (transactionType == "refund") {
      stateClass = "text-info";
      stateIcon = "refresh";
      title = "Refund"
    } else if (transactionType == "chargeback") {
      stateClass = "text-danger";
      stateIcon = "refresh";
      title = "chargeback";
    }

    var tooltip = title + " " + transactionState;

    return <div
      data-toggle="tooltip"
      data-placement="right"
      title={tooltip}
    >
      { this.getNewIconForStatus() }
    </div>
  }
}

TransactionStatusIcon.defaultProps = {
  "stateIcons": {
    "created": "clock",
    "pending": "clock",
    "approved": "check-circle",
    "declined": "alert-round",
    "aborted": "minus-3",
    "error": "alert",
    "refunded": "check-circle",
    "refund_pending": "check-circle"
  },
  "typeIcons": {
    "credit_card": "credit-card",
    "cash": "coins-pile",
    "refund": "credit-card",
    "chargeback": "credit-card",
    "adjustment": "wrench"
  },
  "stateClass": {
    "created": "text-muted",
    "pending": "text-info",
    "approved": "text-success",
    "declined": "text-warning",
    "aborted": "text-danger",
    "error": "text-danger",
    "refunded": "text-success",
    "refund_pending": "text-success"
  },
  "default": "question-mark"
}

class TransactionAmount extends waffle.base.BaseComponent {
  render() {
    var strike = false;
    var strikeClass = "";

    var tranState = this.props.transaction.transactionState;
    if (tranState == "declined" || tranState == "error" || tranState == "aborted") {
      strike = true;
      if (this.props.transaction.transactionState == "declined") {
        strikeClass = "orange";
      }
    }
    return <waffle.misc.Amount
        amount={this.props.transaction.amount}
        strike={strike}
        strikeClass={strikeClass}
      />
  }
}

class TransactionItemsSummary extends waffle.base.BaseComponent {
  checkIfOverflow() {
    var _this = this;
    window.requestAnimationFrame(function() {
      if (_this && _this !== undefined) {
        var node = ReactDOM.findDOMNode(_this);
        if (node !== undefined) {
          if (node.offsetWidth < node.scrollWidth) {
            node.className = node.className + " overflowed";
          } else {
            node.className = "transaction-item-summary";
          }
        }
      }
    });
  }

  handleResize() {
    this.checkIfOverflow();
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize.bind(this));
    this.checkIfOverflow();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  getItemInsides(isIntegration, items) {
    return <div className="items-container">
      {
        items.map(item => {
          if (isIntegration && item.isTip == false) {
            return
          } else {
            return <TransactionItem item={item} key={item.uuid}/>
          }
        })
      }
    </div>
  }

  getItemPopoverInsides(items) {
    return <div className="items-container">
      {
        items.map(item => {
          var note = "";
          if (item.note) {
            note = "(" + item.note + ")";
          }
          return <div key={"popover-" + item.uuid}>
            {item.quantity} x {item.name || "Custom amount"} {note}
          </div>
        })
      }
    </div>
  }

  getItems() {
    var isIntegration = false;
    var items = [];
    if (this.props.transaction && this.props.transaction.items) {
      items = this.props.transaction.items;
      isIntegration = this.props.transaction.user &&
        this.props.transaction.user.userType == 'integration';

      if (items.length > 0 && !isIntegration) {
        var overlay = (
          <ReactBootstrap.Popover title="Items" id="item summary">
            { this.getItemPopoverInsides(items) }
          </ReactBootstrap.Popover>
        )

        return <ReactBootstrap.OverlayTrigger ref='popover' trigger={['hover']} placement='left' overlay={overlay}>
          { this.getItemInsides(isIntegration, items) }
        </ReactBootstrap.OverlayTrigger>
      }
    }

    return this.getItemInsides(isIntegration, items)
  }

  getNote() {
    if (this.props.transaction && this.props.transaction.note) {
      var overlay = (
        <ReactBootstrap.Popover title="Transaction note" id="transaction note">
          {this.props.transaction.note}
        </ReactBootstrap.Popover>
      )

      return <ReactBootstrap.OverlayTrigger ref='popover' trigger={['hover']} placement='right' overlay={overlay}>
        <div className="note-container">
          <i className="icon-edit"></i>
          {this.props.transaction.note}
        </div>
      </ReactBootstrap.OverlayTrigger>
    } else {
      return
    }
  }

  render() {
    return <div className="transaction-item-summary">
      { this.getItems() }
      { this.getNote() }
    </div>
  }
}

class TransactionItem extends waffle.base.BaseComponent {
  getNote() {
    if (this.props.item.isTip) {
      return <span className="note">
        R {numeral(this.props.item.amount).format('0,0.00')}
      </span>
    } else if (this.props.item.note) {
      return <span className="note">{ this.props.item.note }</span>
    } else {
      return
    }
  }

  getQuantity() {
    if (this.props.item.quantity > 1) {
      return <span className="quantity">{ this.props.item.quantity }</span>
    } else {
      return
    }
  }

  getClassName() {
    var divClass = "transaction-item-div";
    if (this.props.item.note || this.props.item.isTip) {
      divClass += " has-note";
    }

    return divClass;
  }

  getName() {
    if (this.props.item.name) {
      return this.props.item.name
    } else {
      return "Custom Amount"
    }
  }

  render() {
    return <div className={this.getClassName()}>
      { this.getQuantity() }
      <span className="name">{ this.getName() }</span>
      { this.getNote() }
    </div>
  }
}

class TransactionReceipt extends waffle.base.BaseComponent {
  getItemIcon(basketItem) {
    if (basketItem.inventoryItemData) {
      return <items.ItemIcon
        backgroundColour={basketItem.inventoryItemData.backgroundColour || "0694DC"}
        imageText={basketItem.inventoryItemData.imageText}
        imageURL={basketItem.inventoryItemData.imageURL}
      />
    } else {
      return <items.ItemIcon
        backgroundColour="0694DC"
      />
    }
  }

  getItemNameAndNote(basketItem) {
    var column = "item-name-col";
    if (basketItem.note) {
      column += " has-note";
    }

    return <td className={column}>
      {basketItem.name ? basketItem.name : "Custom amount"}
      <div className="note">
        {basketItem.note}
      </div>
    </td>
  }

  getItems() {
    var basketItems = [];
    var hasInventoryData = false;
    if (this.props.transaction) {
      basketItems = this.props.transaction.items;
      for (var i = 0; i < basketItems.length; i++) {
        if (basketItems[i].inventoryItemData) {
          hasInventoryData = true;
          break;
        }
      }
    }

    var tableClass = hasInventoryData ? "table-container" : "table-container no-inventory-data";
    return <div className={tableClass}>
      <table>
        <tbody>
          {
            basketItems.map(item => {
              var itemName = item.name ? item.name : "Custom amount";
              return <tr key={item.uuid}>
                <td className="item-icon-col">
                  { this.getItemIcon(item) }
                </td>
                <td className="item-name-col">
                  {item.name ? item.name : "Custom amount"}
                  <div className="note">
                    {item.note}
                  </div>
                </td>
                <td className="item-quantity-col">
                  x {item.quantity}
                </td>
                <td className="item-amount-col">
                  <waffle.misc.Amount amount={item.amount}/>
                </td>
              </tr>
            })
          }
        </tbody>
      </table>
    </div>
  }

  getTransactionNote() {
    if (this.props.transaction && this.props.transaction.note) {
      return <div className="transaction-note">
        <i className="icon-edit"></i>
        { this.props.transaction.note }
      </div>
    } else {
      return
    }
  }

  render() {
    var typeDict = {
      "credit_card": "Card",
      "cash": "Cash",
      "refund": "Refund"
    };

    var transactionType = "";
    var excludingAmount = 0;
    var vatAmount = 0;
    var amount = 0;
    var footerClass = "section footer ";
    var iconClass = "state-icon icon-";
    var date = "";

    var receiptNameStyle = {};
    var footerStyle = {};
    var message = "";
    var refundClass = "btn-muted";
    var refundDisabled = true;
    var typeIcon = "";

    var cardNumber = "";

    if (this.props.transaction) {
      transactionType = typeDict[this.props.transaction.transactionType];
      excludingAmount = this.props.transaction.amount -
        this.props.transaction.vatAmount;
      vatAmount = this.props.transaction.vatAmount;
      amount = this.props.transaction.amount;
      date = this.props.transaction.created;

      receiptNameStyle.color = this.props.transaction.transactionSimpleState.colour;
      footerStyle.backgroundColor = this.props.transaction.transactionSimpleState.colour;
      iconClass += this.props.transaction.transactionSimpleState.icon;
      message = this.props.transaction.transactionSimpleState.message;
      if (this.props.transaction.canBeRefunded) {
        refundClass = "btn-warning";
        refundDisabled = false;
      }

      typeIcon = this.props.transaction.transactionSimpleState.typeIcon;

      if (this.props.transaction.payworksTransaction) {
        //pad with stars to ensure substring doesn't get out of index
        cardNumber = "*****" + this.props.transaction.payworksTransaction.maskedCard;
        cardNumber = "**** **** **** " + cardNumber.substring(cardNumber.length - 4);
      }
    }

    return <div className="receipt-panel">
      <div className="receipt-container">
        <div className="section receipt-header" style={receiptNameStyle}>
          <div className="left">
            <div>
              Receipt
            </div>
            <div className="date">
              <waffle.misc.DateAndTime date={date}/>
              <waffle.misc.SmallDateAndTime date={date}/>
            </div>
          </div>
          <div className="right">
            <div>
              {transactionType}
            </div>
            <div className="card">
              {cardNumber}
            </div>
          </div>
        </div>

        { this.getTransactionNote() }
        <div className="section">
          {this.getItems()}
        </div>
        <div className="section totals">
          <div className="total">
            Excluding
            <div className="amount">
              <waffle.misc.Amount amount={excludingAmount}/>
            </div>
          </div>
          <div className="total">
            VAT
            <div className="amount">
              <waffle.misc.Amount amount={vatAmount}/>
            </div>
          </div>
        </div>
        <div className="section totals final" style={receiptNameStyle}>
          Total
          <div className="amount">
            <waffle.misc.Amount amount={amount}/>
          </div>
        </div>
        <div className="section footer" style={footerStyle}>
          <i className={iconClass}></i>
            {message}
          <i className={"type-icon " + typeIcon}></i>
        </div>
      </div>
    </div>
  }
}

class TransactionLifespan extends waffle.base.BaseComponent {
  getLifecycleItem(isCurrentState, simpleState, userName, subtext, date) {
    var detailsClass = "details";
    if (!subtext) {
      detailsClass += " no-subtext";
    }
    var containerClass = "life-span-event";
    if (isCurrentState) {
      containerClass += " active";
    }
    return <div className={containerClass} key={date}>
      <div className={isCurrentState ? "circle " : "circle"} style={{background: simpleState.colour}}>
        <div className="container-icon">
          <i className={"icon-" + simpleState.icon}></i>
        </div>
      </div>
      <div className="date">
        <div>
          <span className="lighter"> { moment(date).format("dddd") } </span>
          { moment(date).format("h:mm a") }
        </div>
        <div>
          { moment(date).format("Do") }
          <span className="lighter"> of </span>
          { moment(date).format("MMMM") }
        </div>
      </div>
      <div className="details">
        <div className={ subtext ? "" : "no-subtext" }>
          <div className="detail">{simpleState.message}</div>
          <span> by </span>
          <div className="detail">{userName}</div>
        </div>
        <waffle.misc.If test={subtext}>
          <div className="subtext">
            {subtext}
          </div>
        </waffle.misc.If>
      </div>
    </div>
  }

  getLineItems() {
    if (this.props.transaction.transactionHistory) {
      return this.props.transaction.transactionHistory.map(row => {
        return this.getLifecycleItem(row.transactionUUID == this.props.transaction.uuid, row.simpleState, row.user.fullName, row.subtext, row.date)
      })
    } else {
      return this.getLifecycleItem(true, this.props.transaction.transactionSimpleState, this.props.transaction.user.fullName, "", this.props.transaction.created)
    }
  }

  render() {
    if (this.props.transaction) {
      return <div className="transaction-life-span">
          <div className="dotted-line"></div>
          { this.getLineItems() }
        </div>
    } else {
      return <div></div>
    }
  }
}

module.exports = {
  TransactionItemsSummary: TransactionItemsSummary,
  TransactionReceipt: TransactionReceipt,
  TransactionLifespan: TransactionLifespan,
  TransactionStatusIcon: TransactionStatusIcon,
  TransactionAmount: TransactionAmount
}
